import { MAP_STYLE } from "../../contexts/WorldMapContext/constants";
import { CALENDAR_VIEW, CALENDAR_VIEW_SIZE, initAutoPlanConfig, KEY_TAB, PriorityTime, THEME_COLOR } from "./constants";
import {
    DashboardSetting,
    GlobalSetting,
    OverviewSetting,
    PlanSetting,
    PreferenceSetting,
    RouteSetting,
    SiteOverviewSetting,
    VesselSetting,
} from "./userSetting";

const defaultSetting = {
    [DashboardSetting.SECTION_FILTER]: ['1'],
    [DashboardSetting.VESSELS]: [],
    [DashboardSetting.ACTIVE_SITE]: false,
    [DashboardSetting.FACTORIES]: true,
    [DashboardSetting.PRODUCT_AREA]: true,
    [DashboardSetting.PRODUCT_AREAS]: [],
    [DashboardSetting.DISEASED_ZONE]: {},

    [PlanSetting.BIOLOGY_TAB]: KEY_TAB.PRODUCTION,
    [PlanSetting.VESSEL_FILTER]: [],
    [PlanSetting.CALENDAR_VIEW]: CALENDAR_VIEW.VERTICAL,
    [PlanSetting.CALENDAR_VIEW_SIZE]: CALENDAR_VIEW_SIZE.ZOOM_IN,

    [PreferenceSetting.SHOW_CERTAINTY]: true,
    [PreferenceSetting.AUTO_PLAN]: initAutoPlanConfig,
    [PreferenceSetting.CUSTOMIZE_HARVEST]: [],
    [PreferenceSetting.PRIORITY_TIME]: PriorityTime.FACTORY,
    [PreferenceSetting.SITES_TIME]: {},
    [PreferenceSetting.FACTORIES_TIME]: {},
    [PreferenceSetting.VIEW_MODE]: undefined,
    [PreferenceSetting.THEME_COLOR]: THEME_COLOR.LIGHT,

    [OverviewSetting.VESSEL_FILTER]: [],
    [OverviewSetting.CREW_VESSEL_FILTER]: [],
    [OverviewSetting.WELLBOAT_FILTER]: [],
    [OverviewSetting.WEEK_PER_PAGE]: 4,
    [OverviewSetting.VESSEL_ORDER]: [],
    [OverviewSetting.SITE_ORDER]: [],
    [VesselSetting.VESSEL_FILTER]: [],

    [SiteOverviewSetting.UNITS_REGIONS_FILTER]: "_",
    [SiteOverviewSetting.UNITS_PROD_AREA_FILTER]: [],
    [SiteOverviewSetting.UNITS_ACTIVE_UNIT_FILTER]: false,

    [RouteSetting.AUTO_ROUTE]: {
        mode: 'Exact',
        safe_depth: 10,
        airDraft: 10
    },
    [GlobalSetting.WEATHER]: [],
    [GlobalSetting.MAP_STYLE]: MAP_STYLE.AUBERGINE,
    [GlobalSetting.MAIL]: {},
}

export const getSetting = (setting: any, key: string) => {
    const { [key]: value = defaultSetting[key] } = setting || {};
    return value;
}

export const getMultiSetting = (setting: any, keys: string[]) => {
    return keys.reduce((rs: any, key) => {
        rs[key] = getSetting(setting, key);
        return rs;
    }, {})
}

export default defaultSetting
